import instance from "./axios.base";

const getCities = async () => {
  const res = await instance.get("/cities");
  return res.data;
};

export { getCities };
